<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش تنظیمات"
    dialogId="update-match-setting-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendUpdateMatchSettingRequest"
  >
    <template v-if="matchSettingDetails">
      <BCol cols="12">
        <TextInput
          inputId="title"
          inputLabel="عنوان تنظیمات"
          inputPlaceholder="مسابقه آیلتس..."
          v-model="matchSettingDetails.title"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          inputId="updateTotalMatchQuestionsCount"
          inputLabel="تعداد سوالات مسابقه"
          inputPlaceholder="5"
          v-model="matchSettingDetails.totalMatchQuestionsCount"
        ></TextInput>
      </BCol>
    </template>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultMatchSettings: {
      type: Object,
      required: false,
    },
  },
  watch: {
    defaultMatchSettings: {
      handler(val) {
        if (val) {
          this.matchSettingDetails = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      matchSettingDetails: null,
    };
  },
  methods: {
    async sendUpdateMatchSettingRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateMatchSetting = new UpdateMatchSetting(_this);
        updateMatchSetting.setRequestParamDataObj(_this.matchSettingDetails);
        await updateMatchSetting.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تنظیمات مسابقه با موفقیت ویرایش شد.",
              },
            });
            this.$bvModal.hide("update-match-setting-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    TextInput,
    BCol,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import { UpdateMatchSetting } from "@/libs/Api/Matches";
import { BCol } from "bootstrap-vue";
</script>
